<template>
  <div>
    <div>
      <h5>Заказ на сумму: {{ order.price_total | spaceBetweenNumber }} UZS</h5>
      <h5>Заказчик: {{ order.client.full_name }}</h5>
      <h5>Товары:</h5>
      <ul>
        <li v-for="(purchase, key) in order.purchases" :key="key">
          {{ key + 1 }}. {{ purchase.name }} {{ purchase.price }} ({{
            purchase.quantity
          }})
        </li>
      </ul>
      <hr />
      <h5>
        Договор: <a target="_blank" :href="transaction.act_original">Скачать</a>
      </h5>
      <h5>
        Договор с подписью:
        <a target="_blank" :href="transaction.act">Скачать</a>
      </h5>
    </div>

    <h3 v-if="!transaction.done">
      {{ "apply_order_pls" | setText("Подтвердите заказ") }}
    </h3>

    <h3 v-else class="text-success">
      {{ "order_done" | setText("Заказ выполнен") }}
    </h3>
    <div class="install-control">
      <!-- <button @click="getStatus" class="btn btn-success">
        {{ "check_status" | setText("Проверить статус") }}
      </button> -->

      <button v-if="!transaction.done" @click="send" class="btn btn-success">
        {{ "check" | setText("Подтвердить заказ") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      let data = {
        app_id: this.transaction.exchange_id
          ? this.transaction.exchange_id
          : this.value.data.app_id,
      };

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}contract/sign`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              client_confirmed: 1,
              system_confirmed: 1,
            });
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.createTransaction({
            client_confirmed: 1,
            system_confirmed: 1,
          });
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },

    getStatus() {
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}application/status/${
          this.transaction.exchange_id
            ? this.transaction.exchange_id
            : this.value.data.app_id
        }`,
        method: "GET",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      limit: null,
      level: null,
    };
  },
};
</script>

